import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['BulkAssignShifts', 'BulkAssignSchedule']
});

const bulkAssignShiftsApi = apiWithTags.injectEndpoints({
	endpoints: (build) => ({
		getFacilityBulkAssignProfessionals: build.query({
			query: ({ facilityId }) => ({
				url: `/flex/facility/${facilityId}/bulk-assign-professionals`
			}),
			providesTags: (result, error, { facilityId }) => [{ type: 'BulkAssignShifts', id: facilityId }]
		}),
		getCaregiverSchedule: build.query({
			query: ({ facilityId, caregiverId }) => ({
				url: `/flex/facility/${facilityId}/caregiver/${caregiverId}/bulk-assign-schedule`
			}),
			providesTags: (result, error, { caregiverId }) => [{ type: 'BulkAssignSchedule', id: caregiverId }]
		}),
		submitBulkCreateAndAssign: build.mutation({
			query: ({ facilityId, caregiverId, shiftsData }) => ({
				url: `/flex/facility/${facilityId}/shifts/bulk-assign`,
				method: 'POST',
				body: { caregiverId, shiftsData }
			}),
			invalidatesTags: (result, error, { caregiverId }) => [
				'BulkAssignShifts',
				{ type: 'BulkAssignSchedule', id: caregiverId }
			]
		})
	})
});

export const {
	useGetFacilityBulkAssignProfessionalsQuery,
	useGetCaregiverScheduleQuery,
	useSubmitBulkCreateAndAssignMutation
} = bulkAssignShiftsApi;

export default bulkAssignShiftsApi;
